import { useState } from 'react'

export const useCompanyDetails = () => {
  const [currentCompanyIndex, setCurrentCompanyIndex] = useState(-1)

  return {
    currentCompanyIndex,
    setCurrentCompanyIndex
  }
}
